function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* SVGR has dropped some elements not supported by react-native-svg: title */
import * as React from 'react';
import { memo } from 'react';
import Svg, { G, Path } from 'react-native-svg';
const Edit = props => /*#__PURE__*/React.createElement(Svg, _extends({
  width: "40px",
  height: "40px",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement(G, {
  transform: "translate(-965 -704.5) translate(965 704.5)",
  fill: "#0A4A8D",
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement(Path, {
  d: "M33.846 36.923H3.076V6.153h18.462V3.078H3.077A3.078 3.078 0 000 6.154v30.77A3.078 3.078 0 003.077 40h30.77a3.078 3.078 0 003.076-3.077V18.462h-3.077v18.461z"
}), /*#__PURE__*/React.createElement(Path, {
  d: "M12.3076923 28.7179487L18.8982988 28.7179487 34.8717949 12.7795417 28.2315126 6.15384615 12.3081098 22.0422699z"
}), /*#__PURE__*/React.createElement(Path, {
  d: "M39.062 3.199L36.802.938a3.194 3.194 0 00-4.522 0l-2.536 2.536 6.782 6.782 2.536-2.536a3.194 3.194 0 000-4.522z"
})));
const EditIcon = /*#__PURE__*/memo(Edit);
export default EditIcon;
//# sourceMappingURL=EditIcon.js.map